import { isString as r } from "lodash-es";
function c(x, a) {
  if (a)
    switch (a) {
      case "ImmiCard":
        return {
          mask: "***999999"
        };
      case "MobileNumber":
        return {
          mask: r(x) ? x.charAt(0) === "+" ? "abc dxx xxx xxx" : "adxx xxx xxx" : "",
          formatChars: { x: "[0-9]", a: "[+0]", b: "[6]", c: "[1]", d: "[4]" }
        };
      case "HomePhoneNumber":
        return {
          mask: r(x) ? x.charAt(0) === "+" ? "abc d xxxx xxxx" : "ad xxxx xxxx" : "",
          formatChars: { x: "[0-9]", a: "[+0]", b: "[6]", c: "[1]", d: "[2378]" }
        };
      case "WorkPhoneNumber":
        return {
          mask: r(x) ? x.charAt(0) === "+" ? x.charAt(3) === "4" || x.charAt(4) === "4" ? "abc dxx xxx xxx" : "abcd xxxx xxxx" : x.charAt(0) === "0" ? x.charAt(1) === "4" ? "adxx xxx xxx" : "ad xxxx xxxx" : x.charAt(0) === "1" && x.charAt(1) === "8" || x.charAt(0) === "1" && x.charAt(1) === "3" && x.charAt(2) === "0" && (x.charAt(3) === "0" || x.charAt(4) === "0") ? "aeff xxx xxx" : "aex xxx" : "",
          formatChars: {
            x: "[0-9]",
            a: "[+01]",
            b: "[6]",
            c: "[1]",
            d: "[23478]",
            e: "[38]",
            f: "[0]"
          }
        };
      case "MedicareCardNumber":
        return {
          mask: "9999 99999 9",
          formatChars: { 9: "[0-9]" }
        };
      case "MedicareRefNumber":
        return {
          mask: "9",
          formatChars: { 9: "[1-9]" }
        };
      case "AusPassport":
        return {
          mask: r(x) ? parseInt(x.charAt(1)) ? "*9999999" : "**9999999" : ""
        };
      case "ForeignPassport":
        return {
          mask: "**************"
        };
      case "CreditCard":
        return {
          mask: "9999 9999 9999 9999"
        };
      default:
        return;
    }
}
export {
  c as getMasking
};
